import * as React from 'react';
// @ts-expect-error -- TODO: Remove this when checkbox is finalized
import classnames from 'classnames';
import { ICoreContext } from '@msdyn365-commerce/core';
import { SimpleProduct, UnitOfMeasureConversion } from '@msdyn365-commerce/retail-proxy';
// @ts-expect-error -- TODO: Remove this when checkbox is finalized
import { humanizeUnitOfMeasure } from '../unit-of-measure';
import { shouldShowBreakoff } from '../../shared-utils/unit-conversion-utils';

export interface IQuantityBreakoffSelectorProps {
    context: ICoreContext;
    disable?: boolean;
    product: SimpleProduct | undefined;
    quantity: number;
    breakoff: boolean;
    unitConversions?: UnitOfMeasureConversion[];
    onQuantityChange: (quantity: number) => void;
    onBreakoffChange: (breakoff: boolean) => void;
}

const QuantityBreakoffSelector = (props: IQuantityBreakoffSelectorProps) => {
    const {
        context,
        disable,
        product,
        quantity,
        breakoff,
        unitConversions,
        onQuantityChange,
        onBreakoffChange
    } = props;

    const baseClassName = 'quantity-breakoff-selector';
    const canBreakoff = React.useMemo(() => product?.Behavior?.MultipleOfQuantity && product.Behavior.MultipleOfQuantity > 1, [product]);

    React.useEffect(() => {
        // Check if the breakoff option should already be enabled for example if a breakoff quantity has been selected in the cart
        if (product && canBreakoff) {
            const multiplier = product.Behavior!.MultipleOfQuantity || 1;
            const newBreakoff = quantity % multiplier !== 0;
            if (newBreakoff !== breakoff) {
                onBreakoffChange(newBreakoff);
            }
        } else if (product && !canBreakoff && breakoff) {
            onBreakoffChange(false);
        }
    }, [canBreakoff]);

    const onQuantityOptionChange = (newBreakoff: boolean) => {
        if (newBreakoff === breakoff) {
            return;
        }

        // Redo variable here using new option
        const multiplier = product?.Behavior?.MultipleOfQuantity || 1;
        let newQuantity = quantity;

        if (!newBreakoff) {
            newQuantity = Math.trunc(quantity) * multiplier;
        } else {
            newQuantity = Math.ceil(quantity / multiplier);
        }

        onQuantityChange(newQuantity);
        onBreakoffChange?.(newBreakoff);
    };

    const boxesLabel = context.request.locale === 'en-US' ? 'BREAKOFF' : 'ANBREKK';

    if (!canBreakoff || !shouldShowBreakoff(product, unitConversions)) {
        return null;
    }

    return (
        <div className={baseClassName}>
            <div className={`${baseClassName}__options-container`} role='radiogroup' aria-label='TODO'>
                {/* <button
                    className={classnames(`${baseClassName}__option-box`, {
                        'is-selected': product && (canBreakoff && !breakoff),
                        'not-available': product && !canBreakoff
                    })}
                    disabled={!product || !canBreakoff}
                    onClick={() => onQuantityOptionChange(false)}
                >
                    {humanizeUnitOfMeasure(context, product?.DefaultUnitOfMeasure, product)}
                </button>
                <button
                    className={classnames(`${baseClassName}__option-box`, {
                        'is-selected': product && (breakoff || !canBreakoff)
                    })}
                    disabled={!product}
                    onClick={() => onQuantityOptionChange(true)}
                >
                    {boxesLabel}
                </button> */}

                <label className='breakoff-checkbox'>
                    <input
                        className='breakoff-checkbox__input'
                        type='checkbox'
                        checked={!!(product && (canBreakoff && breakoff))}
                        disabled={disable || !product || !canBreakoff}
                        onChange={(e) => onQuantityOptionChange(e.target.checked)}
                    />
                    <span className='breakoff-checkbox__label-container' title={boxesLabel}>
                        <span className='breakoff-checkbox__checkbox'></span>
                        <span className='breakoff-checkbox__label'>{boxesLabel}</span>
                    </span>
                </label>
            </div>
        </div>
    );
};

export default QuantityBreakoffSelector;
